// Whites
export const WHITE = '#ffffff' // standard white used for backgrounds and text
export const WHITE_50 = 'rgba(255, 255, 255, 0.50)'
export const WHITE_23 = 'rgba(255, 255, 255, 0.23)'
export const WHITE_83 = 'rgba(255, 255, 255, 0.83)'

// Blacks
export const DARK = '#32333B'
export const DARK_SECONDARY = '#3C434C'


// Grays
export const GRAY = '#E4E5ED'// just gonna make the call now, we have a ton of different brays that need to be combined
export const GRAY_65 = 'rgba(228, 229, 237, 0.65)'
export const GRAY_50 = 'rgba(227, 229, 237, 0.50)'
export const GRAY_22 = 'rgba(228, 229, 237, 0.22)'
export const BRIGHT_GRAY = '#F1F1F4'
export const LIGHT_GRAY = '#C6C8D9'

// Dark Gray
export const DARK_GRAY = '#070C12'
export const DARK_GRAY_80 = 'rgba(7, 12, 18, 0.80)'
export const DARK_GRAY_60 = 'rgba(7, 12, 18, 0.60)'
export const DARK_GRAY_53 = 'rgba(7, 12, 18, 0.53)'
export const DARK_GRAY_40 = 'rgba(7, 12, 18, 0.40)'
export const DARK_GRAY_20 = 'rgba(7, 12, 18, 0.20)'
export const DARK_GRAY_11 = 'rgba(7, 12, 18, 0.11)'
export const DARK_GRAY_05 = 'rgba(7, 12, 18, 0.05)'

// Blues
export const BLUE = '#1EAEFF'
export const BLUE_25 = 'rgba(30, 174, 255, 0.25)'
export const BRIGHT_BLUE = '#1FADFF'

// Greens
export const BRIGHT_GREEN = '#3AF891'
export const GREEN = '#48D6B4'
export const MINT_GREEN = '#daf7f0'

// Reds
export const RED = '#F83A3A'
export const RED_70 = 'rgba(248, 58, 58, 0.70)' // THIS IS THE HEX at 70% opacity
export const HOT_PINK = '#F83A68'
export const ORANGE_PINK = '#F8485B'

